import { useEffect, useRef } from 'react'

export default function usePolling(callback, {
  enabled = true,
  intervalMs = 5000,
  immediate = true,
} = {}) {
  const inFlightRef = useRef(false)

  useEffect(() => {
    if (!enabled || typeof callback !== 'function') return undefined

    let stopped = false
    const run = async () => {
      if (stopped) return
      if (inFlightRef.current) return
      inFlightRef.current = true
      try {
        await callback()
      } catch {
        // WHY: polling failures are expected occasionally and should not break scheduler loop.
      } finally {
        inFlightRef.current = false
      }
    }

    if (immediate) {
      void run()
    }

    const timer = setInterval(() => {
      void run()
    }, intervalMs)

    return () => {
      stopped = true
      clearInterval(timer)
    }
  }, [callback, enabled, immediate, intervalMs])
}
